const Unauthorized = () => {
    return <h1>Unauthorized</h1>
}

export default Unauthorized;